// extracted by mini-css-extract-plugin
export default {"Layout":"styles_Layout__o5kiT"};